//
// --- Types ---

export type SearchModeType = typeof SEARCH_MODE[keyof typeof SEARCH_MODE];

export type SearchResultViewModeKeyType = keyof typeof SEARCH_RESULT_VIEW_MODE;
export type SearchResultViewModeType = typeof SEARCH_RESULT_VIEW_MODE[SearchResultViewModeKeyType];

//
// --- Constants ---

export const SEARCH_MODE = {
  COMPANY_LISTS: 'company-lists',
  SUPPLIER_SEARCH: 'supplier-search',
  IPAFB_SUPPLIER_SEARCH: 'supplier-search-ipafb'
} as const;

export const SEARCH_RESULT_VIEW_MODE = {
  HYBRID: 'hybrid',
  LIST: 'list',
  TREE: 'tree'
} as const;
